/**
 * Enum indicating the state of the promotion for the filter request.
 */
export enum PromotionState {
  All,
  Active,
  Inactive,
}
